import React, { useState } from 'react';
import { CheckCircle2, Bug } from 'lucide-react';
import { Button } from '../components/Button';
interface PasswordResetSuccessProps {
  onLogin: () => void;
}
export function PasswordResetSuccess({
  onLogin
}: PasswordResetSuccessProps) {
  const [showDebug, setShowDebug] = useState(false);
  return <div className="flex flex-col h-full w-full bg-stone-50 overflow-y-auto relative" data-id="element-873">
      {/* Debug Toggle */}
      <button onClick={() => setShowDebug(!showDebug)} className="absolute top-8 right-2 z-40 w-7 h-7 rounded-full bg-slate-800/70 text-white flex items-center justify-center hover:bg-slate-800 transition-colors" title="Debug panel" data-id="element-874">
        <Bug size={14} data-id="element-875" />
      </button>

      {/* Debug Panel */}
      {showDebug && <div className="absolute top-16 right-2 z-40 bg-slate-800 text-white rounded-2xl p-3 shadow-xl w-56 text-xs animate-in fade-in zoom-in-95 duration-150" data-id="element-876">
          <p className="font-bold text-slate-400 uppercase tracking-wider text-[10px] mb-2" data-id="element-877">
            Debug Panel
          </p>
          <p className="text-slate-400 text-xs px-2 py-1" data-id="element-878">
            This is the success state
          </p>
        </div>}

      {/* Header with Mascot */}
      <div className="flex items-center justify-center p-6 pt-8" data-id="element-879">
        <div className="w-12 h-12 rounded-2xl overflow-hidden border-2 border-white shadow-sm bg-stone-200" data-id="element-880">
          <video autoPlay loop muted playsInline className="w-full h-full object-cover" src="https://cdn.magicpatterns.com/uploads/69mUG6ooMsKbP89Ta37mkt/Katethought_friendly_gym_mascot_character_funny_good_guy_musc_bc3cfd10-111a-4766-8e76-81af2852edc8_2.mp4" data-id="element-881" />
        </div>
      </div>

      <div className="px-6 pb-8 flex-1 flex flex-col items-center justify-center" data-id="element-882">
        {/* Icon */}
        <div className="w-20 h-20 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-6" data-id="element-883">
          <CheckCircle2 size={40} data-id="element-884" />
        </div>

        {/* Content */}
        <div className="text-center mb-8 max-w-sm" data-id="element-885">
          <h1 className="text-2xl font-extrabold text-slate-800 mb-3" data-id="element-886">
            Password updated
          </h1>
          <p className="text-slate-600 font-medium leading-relaxed" data-id="element-887">
            Your password has been updated successfully.
          </p>
        </div>

        {/* Action */}
        <div className="w-full max-w-sm" data-id="element-888">
          <Button type="button" variant="primary" fullWidth onClick={onLogin} data-id="element-889">
            Log in now
          </Button>
        </div>
      </div>
    </div>;
}